var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.winnersGroup.length > 0)?_c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[_c('v-sheet',{staticClass:"confetti"},_vm._l((_vm.orderPlaces),function(winnersPlaces,index){return _c('ContestWinnersPlaces',{key:index,attrs:{"winnersPlaces":winnersPlaces}})}),1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }